import './App.css';

import { Route, Routes } from 'react-router-dom';
import AdminLayout from './Modules/shared/Layout/adminLayout';
import './style.css';
import DefaultLayout from './Modules/shared/Layout/DefaultLayout';
import Login from './Modules/Login/Page/Login';
import RhLayout from './Modules/shared/Layout/rhLayout';
import ProtectedLayout from './Modules/shared/Layout/ProtectedLayout';
import { Betsileo } from './Modules/Page/Betsileo';
import SuiviMensuelTable from './Modules/Page/SuiviMensuel';
import QuestionnaireTable from './Modules/Page/Questionnaire';
import BokimbolaTable from './Modules/Page/Bokimbola';
import BokimpanjifaTable from './Modules/Page/Bokimpanjifa';
import FicheTricycleTable from './Modules/Page/FicheTricycle';
import FicheFanoratanaTable from './Modules/Page/FicheFanoratana';
import HomePage from './Modules/Page/HomePage';


function App() {
  return (
    <>
      <Routes>
        <Route element={<DefaultLayout />}>
          <Route path='/login' element={<Login />} />
        </Route>
        <Route element={<ProtectedLayout />}>
 
        </Route>
        <Route element={<AdminLayout />}>
          <Route path='/' element={<HomePage />} />
          <Route path='/betsileo' element={<Betsileo />} />
          <Route path='suiviMensuel' element={<SuiviMensuelTable />} />
          <Route path='questionnaire' element={<QuestionnaireTable />} />
          <Route path='bokimbola' element={<BokimbolaTable />} />
          <Route path='bokimpanjifa' element={<BokimpanjifaTable />} />
          <Route path='tricycle' element={<FicheTricycleTable />} />
          <Route path='fanoratana' element={<FicheFanoratanaTable/>} />
         
        
        </Route>

        <Route element={<RhLayout />}>
         

        </Route>
      </Routes>
    </>
  );
}

export default App;
